import React, { useState, useEffect, useLayoutEffect } from "react";
import { useUpdateEffect } from "ahooks";
import { connect } from "react-redux";

import AMap from "./AMap";
import LeftContent from "./left";
import RightContent from "./right";
import CenterContent from "./center";
import geo from "./geo";
import API from "../api/screen";

import "./index.scss";
import "../styles/index.scss";

const Index = ({ Common }) => {
  const [Polygon, setPolygon] = useState([]);
  const [lx, setLx] = useState(0);
  const [rx, setRx] = useState(0);
  const [bx, setBx] = useState(0);

  useEffect(() => {
    // if (geo) {
    //   let { features } = geo;
    //   let mapList = [];
    //   features &&
    //     features.length &&
    //     features.forEach((item, index) => {
    //       item.geometry &&
    //         item.geometry.coordinates &&
    //         mapList.push(item.geometry.coordinates[0]);
    //     });
    //     console.log(2222, mapList);
    //   setPolygon(() => {
    //     return [...mapList];
    //   });
    // }
    // API.getDMA().then((res) => {
    //   const { features } = res;
    //   console.log(9999, features);
    //   setPolygon(() => {
    //     return [...features];
    //   });
    // })
  }, []);

  useUpdateEffect(() => {
    showLeft();
    showRight();
    showCenter();
  }, [Common.mapFullScreen]);

  const showLeft = () => {
    let l = lx == 0 ? "-24%" : 0;
    setLx(l);
  };
  const showRight = () => {
    let r = rx == 0 ? "-24%" : 0;
    setRx(r);
  };
  const showCenter = () => {
    let b = bx == 0 ? "-28%" : 0;
    setBx(b);
  };

  return (
    <div className="large-screen-wrap relative">
      {/* <Map Polygon={Polygon} /> */}
      {/* <AMap Polygon={Polygon} /> */}

      <div
        style={{
          width: "426px",
          position: "absolute",
          top: "16px",
          bottom: "0px",
          left: `${lx}`,
          zIndex: "110",
          transition: "all linear 0.5s",
        }}
      >
        <LeftContent showLeft={showLeft} lx={lx} />
      </div>

      <div
        style={{
          width: "1068px",
          position: "absolute",
          bottom: `${bx}`,
          left: "426px",
          top: "16px",
          zIndex: "100",
          transition: "all linear 0.5s",
        }}
      >
        <CenterContent showCenter={showCenter} bx={bx} />
      </div>

      <div
        style={{
          width: "426px",
          position: "absolute",
          top: "16px",
          bottom: "0px",
          right: `${rx}`,
          zIndex: "110",
          transition: "all linear 0.5s",
        }}
      >
        <RightContent showRight={showRight} rx={rx} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    Common: { ...state.Common },
  };
};

export default connect(mapStateToProps)(Index);
